import React from "react";
import { Box } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const UserAvatar = (props) => {
  const { name } = props;
  let size = props.size ? props.size : 40;
  let avatar = null;

  return (
    <Box style={{ position: "relative" }}>
      <AccountCircleIcon
        fontSize={"large"}
        color={"inherit"}
        style={{ color: "white" }}
      />
    </Box>
  );
};

export default UserAvatar;
